import React, { Component } from 'react';
import {
  Button,
  ButtonToolbar,
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  Glyphicon,
} from 'react-bootstrap';

import { compose } from 'recompose';
import _ from 'lodash';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import DropdownList from 'react-widgets/lib/DropdownList';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';

import FileViewer from '../../features/documentViewer/FileViewer';
import ExcelTicketSummary from '../ExcelTicketSummary';

import
{ rotateButtonProps, withRotateButtonState }
  from '../../features/submissionItemViewer/containers/SubmissionItemViewer';
import RejectReasonModal from '../RejectReasonModal';
import '../App.css';

import { rotateClockwise } from '../../features/submissionItemViewer/actions';
import { getUser } from '../../features/authentication/selectors';
import linkWithCredentials from '../../utils/linkWithCredentials';
import { getApiServerUrl } from '../../features/configuration/selectors';
import { downloadingFileAndUpdatingCredentials } from '../../utils/downloadUpdatingCredentials';

export const SUBMISSION_TYPES = [
  { id: 'timesheet', name: 'Timesheet' },
  { id: 'ticket', name: 'Ticket' },
  { id: 'ticket_attachment', name: 'Ticket Attachment' },
];

const propTypes = exact({
  data: PropTypes.object,
  selectedId: PropTypes.number.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
  onReject: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  loggedInUser: PropTypes.object.isRequired,
  rotateClockwiseAction: PropTypes.func.isRequired,
  handleTypeChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectIndex: PropTypes.func.isRequired,
  openSplitModal: PropTypes.func.isRequired,
  ...rotateButtonProps,
});

// TODO: Rename to SubmissionItemViewer
export class ImageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
    };

    this.handleModalConfirm = this.handleModalConfirm.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.convertToSubmissionType = this.convertToSubmissionType.bind(this);
    this.handleSubmissionItemDownload = this.handleSubmissionItemDownload.bind(this);
    this.renderTypeSelect = this.renderTypeSelect.bind(this);
    this.renderSplit = this.renderSplit.bind(this);
  }

  async handleModalConfirm(reason, notifySubmitter, usersToNotify) {
    /* Pass in the list of users from the form */
    try {
      await this.props.onReject(
        this.props.data.submission_item,
        reason,
        notifySubmitter,
        usersToNotify,
      );
    } catch (e) {
      // Handle API Errors ...
    } finally {
      this.setState({ modalShow: false });
    }
  }

  handleModalCancel() {
    this.setState({ modalShow: false });
  }

  handleChange(data) {
    this.props.onTypeChange(data.id);
  }

  convertToSubmissionType(inputType) {
    const index = _.findIndex(SUBMISSION_TYPES, (sType) => {
      return (sType.id === inputType);
    });
    return SUBMISSION_TYPES[index];
  }

  async handleRotateClockwise(selectedIndex) {
    const { startDisableRotate, stopDisableRotate, rotateClockwiseAction } = this.props;
    const { document_id: documentId } = this.props.data.submission_item;
    try {
      startDisableRotate();
      await rotateClockwiseAction(documentId, selectedIndex);
    } finally {
      stopDisableRotate();
    }
  }

  handleSubmissionItemDownload(exportPath) {
    const { apiServerUrl } = this.props;
    const pdfUrl = linkWithCredentials(`${apiServerUrl}${exportPath}`);
    downloadingFileAndUpdatingCredentials(pdfUrl);
  }

  renderTypeSelect(submissionType) {
    return (
      <React.Fragment>
        <ControlLabel className="app-float-left">Type:</ControlLabel>
        <Col md={9}>
          <DropdownList
            name="submission_type"
            inputProps={{
              className: 'form-control app-float-left',
            }}
            value={this.convertToSubmissionType(submissionType)}
            data={SUBMISSION_TYPES}
            onChange={this.handleChange}
            valueField="id"
            textField="name"
          />
        </Col>
        {/* <Col md={6}> */}
        {/* <FormGroup> */}
        {/* /!* TODO: Come back and have a button to show the phone number in a modal *!/ */}
        {/* /!* <ControlLabel>Contact #:</ControlLabel>{submitted_by.cell_number} *!/ */}
        {/* </FormGroup> */}
      </React.Fragment>
    );
  }

  renderSplit() {
    const { openSplitModal } = this.props;
    return (
      <Button
        bsStyle="warning"
        onClick={openSplitModal}
      >
        Split
      </Button>
    );
  }

  render() {
    const { submission_item: item } = this.props.data;
    if (!item) {
      return (
        <div>
          Loading....
        </div>
      );
    }

    const { selectedIndex, selectIndex } = this.props;
    const { submissionType, exportPath } = item;
    const submittedBy = item.submission.submitted_by.fullname;
    const { multipage, fileCount, uploadedFiles } = item.document;
    const file = uploadedFiles.edges[selectedIndex].node;

    const {
      disableRotate,
      loggedInUser,
    } = this.props;

    const { modalShow } = this.state;
    return (
      <div>
        <Form>
          <Row>
            <Col md={6}>
              {!multipage && this.renderTypeSelect(submissionType)}
            </Col>
            <Col md={6}>
              <FormGroup>
                <ButtonToolbar bsClass="btn-toolbar pull-right">
                  {multipage && this.renderSplit()}
                  <Button
                    disabled={disableRotate}
                    bsStyle="info"
                    onClick={() => { return this.handleRotateClockwise(selectedIndex); }}
                  >
                    Rotate
                    <Glyphicon glyph="hand-right" style={{ paddingLeft: '0.5em' }} />
                  </Button>
                  <Button
                    name="reject"
                    bsStyle="danger"
                    onClick={() => { this.setState({ modalShow: true }); }}
                  >
                    Reject
                  </Button>
                </ButtonToolbar>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        <Row>
          <Col>
            <FileViewer
              selectedIndex={selectedIndex}
              selectIndex={selectIndex}
              fileCount={fileCount}
              multipage={multipage}
              file={file}
            />
          </Col>
        </Row>
        <Row>
          <ButtonToolbar>
            <Button
              bsStyle="info"
              onClick={() => { this.handleSubmissionItemDownload(exportPath); }}
            >
              <Glyphicon glyph="download-alt" style={{ marginRight: '0.5em' }} />
              Download Submission
            </Button>
          </ButtonToolbar>
        </Row>
        <RejectReasonModal
          submittedBy={submittedBy}
          show={modalShow}
          onConfirm={this.handleModalConfirm}
          onCancel={this.handleModalCancel}
          loggedInUser={loggedInUser}
        />
      </div>
    );
  }
}

export const ItemQuery = gql`
  query SubmissionItem($id: Int!) {
    submission_item(id: $id) {
      id
      document_id
      exportPath: export_path
      document {
        id
        multipage
        fileCount: file_count
        uploadedFiles: uploaded_files {
          edges {
            node {
              id
              url: view_url
              contentType: content_type
              excelTicketSummary: excel_ticket_summary {
                ...Summary
              }
            }
          }
        }
      }
      submissionType: submission_type
      submission {
        id
        submitted_by {
          id
          fullname
        }
      }
    }
  }
  ${ExcelTicketSummary.fragment}
`;

ImageView.propTypes = propTypes;

const withDate = graphql(ItemQuery, {
  options: (props) => { return { variables: { id: props.selectedId } }; },
});


const mapStateToProps = (state) => {
  return {
    loggedInUser: getUser(state),
    apiServerUrl: getApiServerUrl(state),
  };
};

const mapDispatchToProps = {
  rotateClockwiseAction: rotateClockwise,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withDate,
  withRedux,
  withRotateButtonState,
);


export default enhance(ImageView);
